import { Component } from "react";

export default class FormErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, attempt: 0 };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(`[formulário:${this.props.name || "form"}] erro`, error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="my-6 rounded-xl border border-destructive/50 bg-destructive/10 p-4 space-y-3" data-testid="form-error-boundary">
          <p className="text-sm">Algo deu errado. Seus dados digitados foram mantidos.</p>
          <button type="button" onClick={() => this.setState((s) => ({ error: null, attempt: s.attempt + 1 }))}
            className="h-12 w-full rounded-xl bg-primary text-primary-foreground font-semibold press" data-testid="form-error-retry">
            Tentar de novo
          </button>
        </div>
      );
    }
    return <div key={this.state.attempt}>{this.props.children}</div>;
  }
}
